module.exports = __webpack_public_path__ + "static/media/shop-brand-banner.efa95122.jpeg";